/**
 * Lao display labels for the wallet TRANSACTION screens — All-Transactions.vue and the
 * branch-scoped TransactionHistory.vue dialog. These mirror the Go-generated Excel EXPORT
 * wording (internal/wallet/labels.go in hal-branch-wallets) so a row reads identically on
 * screen and in an exported sheet — the openspec `render-swt-detail-frontends` label contract.
 *
 * DELIBERATELY SEPARATE from walletMonitorLabels.js — do NOT merge the two:
 *   - the Monitor pages (BFF-based) render pay type as "ຈ່າຍຕົ້ນທາງ" and null pre-order as
 *     "Unknown"; these screens + the Excel sheets use the user-specified "ເກັບເງິນ…" wording
 *     and render null pre-order BLANK.
 *   - aligning the Monitor pages to this wording is intentionally OUT OF SCOPE.
 * Also intentionally independent of the app-wide `la_status_shipment_type` shipment map
 * (used by ~16 shipment screens), which this change must not touch.
 */

// shipment_pay_type → Lao, matching internal/wallet/labels.go PayTypeLabels.
export const PAY_TYPE_LABELS = {
  origin_freight_fees: 'ເກັບເງິນຕົ້ນທາງ',
  origin_freight_fees_cod: 'ເກັບເງິນຕົ້ນທາງ + COD',
  destination_freight_fees: 'ເກັບເງິນປາຍທາງ',
  destination_freight_fees_cod: 'ເກັບເງິນປາຍທາງ + COD',
};

/**
 * Pay-type label. Unknown/new pay types fall back to the raw value (never blank a cell that
 * has data — mirrors GetPayTypeLabel); an absent field (non-shipment row) renders blank.
 */
export function payTypeLabel(t) {
  if (t === null || t === undefined || t === '') return '';
  return PAY_TYPE_LABELS[t] || t;
}

/**
 * shipment_is_pre_order → Lao, matching GetPreOrderLabel: true → "Pre-Order",
 * false → "ສ້າງໂດຍກົງ", null/absent → blank. The Go admin API serves this as a real JSON
 * boolean (omitted when null); we also tolerate a "1"/"0" string just in case.
 */
export function preOrderLabel(v) {
  if (v === null || v === undefined || v === '') return '';
  if (v === true || Number(v) === 1) return 'Pre-Order';
  if (v === false || Number(v) === 0) return 'ສ້າງໂດຍກົງ';
  return '';
}

/**
 * Route "start → end" for the ເສັ້ນທາງ column: prefer the branch prefix (compact), fall back
 * to the branch name, blank when a side does not resolve. A non-shipment row (neither side
 * present) → ''.
 */
export function routeLabel(row) {
  if (!row) return '';
  const start = row.start_branch_prefix || row.start_branch_name || '';
  const end = row.end_branch_prefix || row.end_branch_name || '';
  if (start && end) return `${start} → ${end}`;
  return start || end || '';
}
